export default {
  data() {
    return {
      locateOpts: [
        {
          title: '首页',
          id: 1
        }
      ]
    }
  }
}